import React from 'react';
import { MdCancel } from 'react-icons/md';
import './Zohomodel.css';

function Zohomodel({ onClose, onCreateReferral, onLinkToExistingZoho, zohoData }) {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <span className="modal-title">Send To Zoho</span>
          <MdCancel className="close-modal" size={24} onClick={onClose} />
        </div>

        <div className="add-client">
          {/* Create New Referral Button */}
          <button className="action-btn-2" onClick={onCreateReferral}>
           Add this referral as New Shark (Without Linking)
          </button>

          {/* OR separator */}
          <div className="or-separator">
            <span>OR</span>
          </div>

          {/* Already Linked Button */}
          <span className="action-btn-1">
            Link this Referral to existing Zoho Shark(Select Anyone)
          </span>

          {/* Show Zoho Data Cards */}
          {zohoData && zohoData.length > 0 && (
            <div className="zoho-card-container">
              {zohoData.map(({ name, Phone, Install_Status, id }, index) => (
                <div className="zoho-card" key={index}>
                  <p className='zoho-name'>
                    <span className="zoho-label">Name:</span> {name || 'N/A'}
                  </p>
                  <p className='zoho-name'>
                    <span className="zoho-label">Phone:</span> {Phone || 'N/A'}
                  </p>
                  <p className='zoho-name'>
                    <span className="zoho-label">Status:</span> {Install_Status || 'N/A'}
                  </p>

                  <button
                    className="zoho-link-btn"
                    onClick={() => onLinkToExistingZoho(id)}
                  >
                    Link to this Zoho Shark
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Zohomodel;
